/* eslint-disable */
function type(value) {
    return Object.prototype.toString
        .call(value)
        .replace(/^\[object (.+)\]$/, "$1")
        .toLowerCase();
}
export default {
    isString: function (value) {
        return type(value) === "string";
    },
    isFunction: function (value) {
        return type(value) === "function";
    },
    isArray: function (value) {
        return Array.isArray(value);
    },
    isNumber: function (value) {
        return !this.isArray(value) && value - parseFloat(value) + 1 >= 0;
    },
    isDomElement: function (value) {
        return typeof HTMLElement === "object" || typeof HTMLElement === "function"
            ? value instanceof HTMLElement || (typeof SVGElement !== "undefined" && value instanceof SVGElement)
            : value &&
                typeof value === "object" &&
                value !== null &&
                value.nodeType === 1 &&
                typeof value.nodeName === "string";
    },
    isNodeList: function (value) {
        return type(value) === "nodelist";
    },
    /**
     * Method to check if an item is an object. Date and Function are considered
     * an object, so if you need to exclude those, please update the method accordingly.
     *
     * @param item - The item that needs to be checked
     *
     * @return {boolean} Whether or not @item is an object
     */
    isObject: function (value) {
        return value === Object(value) && !Array.isArray(value) && !this.isDomElement(value) && !this.isFunction(value);
    },
    isAnimationDescriptor: function (obj) {
        return obj.yoyo !== undefined;
    },
    isSceneDescriptor: function (obj) {
        return obj.hook !== undefined && obj.speed === undefined;
    },
    isParallaxDescriptor: function (obj) {
        return obj.hook !== undefined && obj.speed !== undefined;
    }
};
//# sourceMappingURL=type.helper.js.map